import { Request } from '@group-devs/yfp7-global-modules'
import { Container } from 'react-bootstrap'
import Link from 'next/link';
import { FaRegPlayCircle } from "react-icons/fa";

const request = new Request(process.env.apiDomain)

function HelpMe (props) {
    const { data: profile } = request.account.swrAccountProfile(props.site.accountId)

    return (
        <>
        <div className="section-help-me">
            <Container className="text-center">
                <h2>Yes! I want to explore natural ways to feel healthier, more energetic and more focused</h2>
                <p><Link href="/explore/tour" passHref><a className="btn btn-watch-videos2"><FaRegPlayCircle size={34} className="mr-3"/>Click to Watch Videos</a></Link></p>
            </Container>
        </div>
        <style jsx global>{`

                .section-help-me {
                    color: #fff;
                    background: rgba(67,166,73,1.00);
                }

                .section-help-me .container {
                    padding-top: 90px;
                    padding-bottom: 90px;
                }

                .section-help-me h2 {
                    font-size: 26px;
                    line-height: 42px;
                    margin-bottom: 40px;
                }

                .section-help-me .btn-watch-videos2 {
                    font-size: 18px;
                    padding: 10px 40px;
                    text-transform: uppercase;
                    font-weight: 700;
                    border-radius: 50px;
                    background: rgba(67,166,73,1.00);
                    color: #fff;
                    border: 3px solid #fff;
                }

                .section-help-me .btn-watch-videos2:hover {
                    background: #fff;
                    color: rgba(67,166,73,1.00);
                    border: 3px solid #fff;
                }

                @media (max-width: 767.98px) {

                    .section-help-me .container {
                        padding-top: 50px;
                        padding-bottom: 50px;
                    }

                    .section-help-me h2 {
                        font-size: 20px;
                        line-height: 32px;
                        margin-bottom: 30px;
                    }

                    .section-help-me .btn-watch-videos2 {
                        font-size: 14px;
                        padding: 5px 20px;
                    }

                    .section-help-me .btn-watch-videos2 svg {
                        width: 26px;
                    }

                }

            `}</style>
        </>
    );
}

export default HelpMe;